module.exports = __webpack_public_path__ + "img/Tessellate12.ff5c8bdd.jpg";